import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { signupVerification } from '../../actions/auth'
const Verification = ({location, signupVerification}) => {
    const [token, setToken] = useState('')
    const [user, setUser] = useState('')
    useEffect(() => {
        const search = location.search;
        const token = new URLSearchParams(search).get("token");
        const user = new URLSearchParams(search).get("user");
      
            signupVerification(token,user)
        
        
        setToken(token)
        setUser(user)
    }, [])
    return ( 
        <>
        </>
     );
}
 
export default connect(null,{signupVerification})(Verification);